import { mapState } from 'vuex';
import { articlePage, dynamicPage, noticePage } from './components';
export default {
  name: 'userInfo',
  components: {
    dynamicPage,
    articlePage,
    noticePage
  },
  data() {
    return {
      tabList: [{
        key: 'dynamicPage',
        tab: '动态'
      }, {
        key: 'articlePage',
        tab: '文章'
      }, {
        key: 'noticePage',
        tab: '通知'
      }],
      currentKey: 'dynamicPage',
      skillList: [{
        title: 'Vue',
        value: 95,
        status: 'active'
      }, {
        title: 'Ant design vue',
        value: 75,
        status: 'active'
      }, {
        title: 'Echarts',
        value: 60,
        status: 'active'
      }, {
        title: 'ESLint',
        value: 100,
        status: 'success'
      }, {
        title: 'Node',
        value: 100,
        status: 'exception'
      }],
      tagList: [{
        title: '美食爱好者',
        color: '#1890FF'
      }, {
        title: '学习',
        color: '#52C41A'
      }, {
        title: '减肥',
        color: '#52C41A'
      }, {
        title: '赚钱',
        color: '#1890FF'
      }, {
        title: '进大厂',
        color: '#F5222D'
      }],
      addInputShow: false,
      tagValue: ''
    };
  },
  computed: {
    ...mapState({
      accountInfo: state => state.user.accountInfo
    })
  },
  created() {
    this.currentKey = this.$route.params.key || 'dynamicPage';
  },
  methods: {
    changeTab(key) {
      this.currentKey = key;
    },
    inputConfirm() {
      const value = this.tagValue.trim();
      let tagList = this.tagList;
      if (value && this.tagList.findIndex(item => item.title == value) == -1) {
        tagList = [...tagList, {
          title: value,
          color: '#1890FF'
        }];
      }
      Object.assign(this, {
        tagValue: '',
        tagList: tagList,
        addInputShow: false
      });
    },
    writeInput() {
      this.addInputShow = true;
      this.$nextTick(() => {
        this.$refs.input.focus();
      });
    }
  }
};